export const formatChapels = (chapels: { chapelName: string }[]) => {
    if (!chapels.length) return '';

    if (chapels.length === 1) {
        return chapels[0].chapelName;
    }

    if (chapels.length === 2) {
        return `${chapels[0].chapelName} & ${chapels[1].chapelName}`;
    }

    return (
        chapels.slice(0, -1).map(c => c.chapelName).join(', ') 
        + ' and ' +
        chapels[chapels.length - 1].chapelName
    );
};

export const formatChapelNumbers = (chapels: { chapelName: string }[]) => {
    const numbers = chapels
        .map(c => c.chapelName.split(" ")[1])
        .filter(Boolean);

    if (!numbers.length) return "";
    if (numbers.length === 1) return numbers[0];
    if (numbers.length === 2) return `${numbers[0]} & ${numbers[1]}`;

    return (
        numbers.slice(0, -1).join(", ") +
        " and " +
        numbers[numbers.length - 1]
    );
};